
import React from "react";
import styled from "styled-components";
import { FirstBus } from "../molecules/FirstBus";
import { SecondBus } from "../molecules/SecondBus";
import { DirectionText } from "../atoms/DirectionText";


export const RowStopTime = (props) => {
  const {
    platform_code,
    color,
    backColor,
    firstStoptime,
    secondStoptime
  } = props;
  return (
    <SContainer backColor={backColor}>
      <SBusStop color={color}>
        <div>{platform_code}</div>
      </SBusStop>
      <SDirection color={color}>
        <DirectionText platform_code={platform_code} />
      </SDirection>
      <SRowStopTime>
        <SLi>
          <FirstBus stoptime={firstStoptime} color={color} platform_code={platform_code}/>
        </SLi>
        <SLi>
          <SecondBus stoptime={secondStoptime} color={color} platform_code={platform_code}/>
        </SLi>
      </SRowStopTime>
    </SContainer>
  );
};

const SContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  height: 137px;
  border: 3px solid;
  margin: 0px;
  padding: 0px;
  border-left: transparent;
  border-right: transparent;
  border-top: transparent;
  background-color: ${(props) => props.backColor};
`;

const SBase = styled.div`
  display: flex;
  align-items: center; /*上下中央揃え*/
  justify-content: left; /*左右中央揃え*/
  height: 100%;
  padding-top: 0px;
  color: white;
  background-color: ${(props) => props.color};
`;

const SBusStop = styled(SBase)`
  width: 40px;
  font-family: "Roboto";
  font-size: 36px;
  font-weight: 500;
  div {
    margin-left: 10px;
  }
`;

const SDirection = styled(SBase)`
  width: 160px;
  font-size: 18px;
  background-color: ${(props) => props.color};
  text-align: left;
`;

const SRowStopTime = styled.div`
  width: calc(100% - 200px);
`;

const SLi = styled.li`
  list-style: none;
`;
